<template>
  <section>
    <div class="gr w-full">
      <div class="-mt-48 w-full">
        <p class="font-bold text-ma-gray-3 text-center text-sm uppercase tracking-widest mx-auto mb-8">It’s really that simple</p>
        <div
          id="btn_video"
          class="bg-ma-black-0 w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl mx-auto relative flex justify-center items-center"
          @click="playVideo"
          v-show="!isPlaying"
        >
          <div class="absolute flex w-full h-full justify-center items-center">
            <img class="w-10 sm:w-20" src="/assets/images/content/license/icon-play.svg" />
            <div class="absolute top-0 cursor-pointer w-full h-full bg-ma-black-0 opacity-25 hover:opacity-0 z-50">
          </div>
          </div>
          <div class="video-container">
          </div>
        </div>
        <div
          v-show="isPlaying"
          class="bg-ma-black-0 w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl mx-auto relative flex justify-center items-center"
        >
          <div class="video-container">
           	<video
              ref="vjs" class="video-js"
            ></video>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import { getAssetPath } from '@/utils/contentDelivery';

export default {
  data: () => ({
    url: getAssetPath("explainer-reels/marketplace/motion-array-licenses-51657-PREVIEW.mp4"),
    vjs: null,
    isPlaying: false,
  }),
  mounted() {
    this.$nextTick(() => {
      const vjsEl = this.$refs.vjs;
      this.vjs = videojs(vjsEl, {
        fluid: true,
        playsinline: true,
        inactivityTimeout: 0,
        controls: true,
        controlBar: {
          children: [
            "playToggle",
            "progressControl",
            "currentTimeDisplay",
            "timeDivider",
            "durationDisplay",
            "volumePanel",
            "fullscreenToggle",
          ],
          playToggle: {
            replay: false,
          },
          volumePanel: {
            inline: false,
          },
        },
      });
      this.vjs.src(this.url);
    });
  },
  beforeDestroy() {
    if (this.vjs) {
        this.vjs.dispose();
    }
  },
  methods: {
    playVideo(event) {
      this.vjs.play();
      this.isPlaying = true;
    },
  },
};
</script>

<style scoped>
  #btn_video {
    background-image: url(/assets/images/content/license/video-placeholder.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    background-color: #1e1b31;
  }
  .video-js {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }
  .video-container {
    position: relative;
    width: 100%;
    padding-top: calc(56.25% + 40px); /* 16:9 Aspect Ratio */
  }
</style>